/* PRODUCTS */
export const SET_ORDER = "SET_ORDER"
export const SET_ORDER_SUCCESS = "SET_ORDER_SUCCESS"
export const SET_ORDER_FAIL = "SET_ORDER_FAIL"